// ##############################################################

// #             GENEROVANÝ KÓD, NEMODIFIKOVAT!!!!              #

// #                  2019-01-25T10:29:05Z                      #

// ##############################################################

import ErrorApi from "./../../../utils/ErrorApi";
import Fetch from "./../../../utils/Fetch";
import ParamsFetch from "./../../../utils/ParamsFetch";
import JsonFetch from "./../../../utils/JsonFetch";
import generateUrl from './../../../utils/generateUrl';

import * as UpdateMethods from "./UpdateMethods";

/**
 * Service pro tisk štítků a obálek. Generated from cz.marbes.api.dokument.obalky.ObalkaService.
 */
export default class ObalkaApi {
    /**
     * Vytiskne adresní údaje podle zadaných metadat a položek.
     *
     * @param sablonaKod jednoznačný identifikátor použité šablony
     * @param stitky štítky, které budeme tisknout
     * @param odesilatel odesílatel pro tisk na obálku, při null bude odesílatel nevyplněn
     * @param meta další vlastnosti pro tisk obálek, doplňující a řídící údaje tisku, pokud bude předán {@code null} budou použity prázdné hodnoty
     * @param pageOffset nastavení posunu stránky (vyrovnání chyby podavače), při null bude posun 0 v obou směrech
     * @return Renderované štítky ve formátu PDF
     */
    static tisk(sablonaKod : string, stitky : Stitek[], odesilatel : Subjekt, meta : TiskAdresMeta, pageOffset : PageOffset) : String {
        const uri = serverContextPath + `/api/obalky/sablona/${sablonaKod}/stream`;
        const params = { odesilatel, meta, pageOffset };
        return generateUrl(uri, params, true);
    }

    /**
     * 
     *
     * @param sablonaKod jednoznačný identifikátor použité šablony
     * @return instance vyplněná dle zvolené šablony
     */
    static createTiskAdresMetaDefault(sablonaKod : string) : Promise<TiskAdresMeta> {
        const uri = serverContextPath + `/api/obalky/sablona/${sablonaKod}/create`;
        const headers = undefined;
        const params = {  };
         
        return ErrorApi.responseResolver(JsonFetch.post(uri, params, 0, headers));
    }

    /**
     * Vrací testovací stránku.
     *
     * @param pageOffset posun tisku
     * @return testovací stránka
     */
    static tiskTestovaciStranky(pageOffset : PageOffset) : String {
        const uri = serverContextPath + `/api/obalky/testovaci/stranka/stream`;
        const params = {  };
        return generateUrl(uri, params, true);
    }

    /**
     * Najde konkrétní šablonu dle kódu.
     *
     * @param sablonaKod kód šablony
     * @return šablona
     */
    static getObalkaSablonaByKod(sablonaKod : string) : Promise<ObalkaSablona> {
        const uri = serverContextPath + `/api/obalky/sablona/${sablonaKod}`;
        const headers = undefined;
        const params = {  };
         
        return ErrorApi.responseResolver(JsonFetch.get(uri, params, headers));
    }

    /**
     * Vytiskne testovací štítek s umělými daty.
     *
     * @param sablonaKod kód šablony
     * @param pageOffset posun tisku
     * @return testovací štítek
     */
    static zkusebniTisk(sablonaKod : string, pageOffset : PageOffset) : String {
        const uri = serverContextPath + `/api/obalky/testovaci/sablona/${sablonaKod}/stream`;
        const params = { pageOffset };
        return generateUrl(uri, params, true);
    }

    /**
     * Vrácí seznam nakonfigurovaných adresních štítků.
     *
     * @return seznam adresních štítků
     */
    static getSablony() : Promise<ObalkaSablona[]> {
        const uri = serverContextPath + `/api/obalky/sablony`;
        const headers = undefined;
        const params = {  };
         
        return ErrorApi.responseResolver(JsonFetch.get(uri, params, headers));
    }

}